import { NonIdealState, Spinner } from "@blueprintjs/core";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { StyledCard as Card } from "~/layouts/StyledCard";

class Loader extends React.Component<WithTranslation> {
  public render() {
    const { t } = this.props;
    return (
      <Card>
        <NonIdealState
          icon={<Spinner />}
          title={t("title")}
          description={t("description").toString()}
        />
      </Card>
    );
  }
}

export default withTranslation("loader")(Loader);



// WEBPACK FOOTER //
// ./src/components/TrackTrace/Loader.tsx